import Vue from 'vue';
import Vuex from 'vuex'
import i18n from '@/i18n.js' 


Vue.use(Vuex)

export const store = new Vuex.Store({
    
    state:{
        catdb:[
            {'id':'uncategorized','name':"Sin categoria",'parents':[],'level':0,'children':[],
            'desc':'Productos sin descripicion','parentid':'','qtyprod':0,invAlert:25,'childs':0}
        ],
        products:[],
        fournDb:[
            {'id':'fourn1','name':i18n.t('noFournName')}
        ],
        propriedades:[],
        sales:[],
        bills:[],
        clients:[
            {"id":'noClient',"name":i18n.t('noClient.nameNoclient'),"type":i18n.t('noClient.typeNoclient'),"tel":'',"compras":[],"total_compra":0},
        ]
        
        //spa:data
    },
    getters:{
        
        getHeadersProps:state=>{
            
            var prodheaders= [
                { text: i18n.t('headers.actions'), width:'125', value: 'actions', sortable: false,class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                {
                  text: i18n.t('headers.prodCode'),
                  align: 'start',
                  width:'175',
                  value: 'codigo',
                  class: 'quaterny primary--text font-weight-black text-subtitle-2' 
                },
                {
                  text: i18n.t('headers.prodName'),
                  align: 'start',
                  value: 'name',
                  width:"450",
                  class: 'quaterny primary--text font-weight-black text-subtitle-2'
                },
                { text: i18n.t('headers.prodDesc'),width:"450", value: 'desc', sortable:false,class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                { text: i18n.t('headers.prodPubuy'), width:'75', value: 'pu_buy',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                { text: i18n.t('headers.prodPusell'), width:'75', value: 'pu_sell',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                { text: i18n.t('headers.prodCat'),width:'175', value: 'catname',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                { text: i18n.t('headers.prodAvail'), width:'75', value: 'currenttInv',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
                
              ];
          var size = state.propriedades.length;
          
          for(var i=0;i<size;i++){
           prodheaders.push({ text: state.propriedades[i].name,width:'125', value: state.propriedades[i].name,class: 'quaterny primary--text font-weight-black text-subtitle-2' })
            }

            return prodheaders
          },
        treeviewCatDb:state=>{
            var catdb=JSON.parse(JSON.stringify(state.catdb))
            var lvl = 0
            var tempcat={}
            var u
            var i
            var parentid

            // count how many lvls max
            for(i=0;i<catdb.length;i++){
            if (catdb[i].level>lvl){lvl=catdb[i].level}
            }
            console.log('lvl : ',lvl)

            // if only base lvl, no need to build treeview
            if(lvl==0){
            return state.catdb
            }
            else{
                for(u=lvl;u>0;u--){
                //for each lvl starting from highest, go through the temp database catdb
                for(i=0;i<catdb.length;i++){
                    if(catdb[i].level==u){
                    //When found a categorie from current lvl, found the position of its parent and add it to its child
                    parentid = catdb[i].parentid
                    let parentpos = catdb.map(function (e) {
                        return e.id;
                        }).indexOf(parentid);
                        tempcat=catdb[parentpos]
                        tempcat.children.push(catdb[i])
                        
                        //remove the cat that has been added to childs from the temp db
                        //replace the parent by the parent with child
                        catdb.splice(i,1)
                        catdb.splice(parentpos,1,tempcat)
                        i=0
                    }
                }
                }

            }//end of all (else if not just base lvl)
        return catdb
        },
        prodList:state=>{
            return state.products
        },
        fournDb:state=>{
            return state.fournDb
        },
        propsDb:state=>{
            return state.propriedades
        },
        catdb:state=>{
            return state.catdb
        },
        clientDb:state=>{
            return state.clients
        }
        
    },
    mutations:{
        deleteCat:(state,payload)=>{
            var pos = 0
            //update parent child count if necessary
            if(payload.parentid){
                pos=state.catdb.map(function(e) { return e.id; }).indexOf(payload.parentid);
                state.catdb[pos].childs-=1
            }
            pos=state.catdb.map(function(e) { return e.id; }).indexOf(payload.id);
            state.catdb.splice(pos,1)
            
        },
        deleteProd:(state,payload)=>{
            var catpos = 0
            var pos=0
            //update categorie prod count
           
                catpos=state.catdb.map(function(e) { return e.id; }).indexOf(payload.catid);
                state.catdb[catpos].qtyprod-=1
            
            pos=state.products.map(function(e) { return e.id; }).indexOf(payload.id);
            state.products.splice(pos,1)
            
        },
        deleteProp:(state,payload)=>{
            var  pos=state.propriedades.map(function(e) { return e.id; }).indexOf(payload.id);
            state.propriedades.splice(pos,1)
            
        },
        deletebill:(state,payload)=>{
            var  pos=state.bills.map(function(e) { return e.id; }).indexOf(payload.id);
            state.bills.splice(pos,1)
            
        },

        deleteClient:(state,payload)=>{
            var  pos=state.clients.map(function(e) { return e.id; }).indexOf(payload.id);
            state.clients.splice(pos,1)
            
        },
        deleteSale:(state,payload)=>{
            var  pos=state.sales.map(function(e) { return e.id; }).indexOf(payload.id);
            state.sales.splice(pos,1)
            
        },
        addCat:(state,payload)=>{
            state.catdb.push(payload)
        },
        addBuy:(state,payload)=>{
            state.bills.push(payload)

            var  pos=state.products.map(function(e) { return e.id; }).indexOf(payload.prodid);
            state.products[pos].currenttInv+=payload.qty;

            
        },
       
        addSale:(state,payload)=>{
            state.sales.push(payload)

            var pos=state.clients.map(function(e) { return e.id; }).indexOf(payload.clientId);
                        
            state.clients[pos].total_compra+=payload.total
            state.clients[pos].compras.push(payload.id)

            
            var invProd = 0
            for(var i=0;i<payload.products.length;i++){
                pos=state.products.map(function(e) { return e.id; }).indexOf(payload.products[i].id);
                invProd = state.products[pos].currenttInv
                state.products[pos].currenttInv=invProd-payload.products[i].qty
            }
        },
        addProp:(state,payload)=>{
            //console.log("store ;",payload)
            state.propriedades.push(payload)
        },
        addProd:(state,payload)=>{
            //console.log("store ;",payload)
            state.products.push(payload)
            var pos=state.catdb.map(function(e) { return e.id; }).indexOf(payload.catid);
            state.catdb[pos].qtyprod+=1
            
        },
        addClient:(state,payload)=>{
            //console.log("store ;",payload)
            state.clients.push(payload)
            
        },
        modifProp:(state,payload)=>{
            var id = payload.id
        
            let pos = state.propriedades.map(function (e) {
              return e.id;
            }).indexOf(id);
            //console.log(pos)
            state.propriedades[pos].name=payload.name
            state.propriedades[pos].typeform=payload.typeform
            state.propriedades[pos].desc=payload.desc
            state.propriedades[pos].selectoptions=payload.selectoptions
            
                    
        },

        updateCatChildCount:(state,{cat,ammount})=>{
            var pos=state.catdb.map(function(e) { return e.id; }).indexOf(cat.id);
            state.catdb[pos].childs+=ammount
        },
        modifProductCat:(state,{id,newid,catname})=>{
        
            var productsdb = state.products;
            var pos=state.catdb.map(function(e) { return e.id; }).indexOf(id);
            var catprodqty = state.catdb[pos].qtyprod
            
            if(productsdb.length>0){
                for(var i=0; i<productsdb.length;i++){
                    if(productsdb[i].catid==id){
                          state.proddb[i].catid= newid;
                          state.proddb[i].catname= catname;
                          
                          catprodqty += 1 
                          
                          } 
                }              
                                  
                       }
                
                state.catdb[pos].qtyprod=catprodqty
                
            
          },
    
    modifProduct:(state,{id,prod})=>{
        var pos=state.products.map(function(e) { return e.id; }).indexOf(id);
        state.products.splice(pos,1)
            state.products.push(prod)
          },
          modifProductCatQty:(state,{id,ammount})=>{
            var pos=state.catdb.map(function(e) { return e.id; }).indexOf(id);
            state.catdb[pos].qtyprod+=ammount            
          },
        
        modifInv:(state,{id,request,alert})=>{
            var pos=state.products.map(function(e) { return e.id; }).indexOf(id);
            state.products[pos].requestInv=request
            state.products[pos].invAlert=alert
        },
        restoreProdInv:(state,{id,qty})=>{
            var pos=state.products.map(function(e) { return e.id; }).indexOf(id);
            state.products[pos].currenttInv+=qty
        },
        eraseDb:(state)=>{
            state.products=[];
            state.clients=[
                {"id":'noClient',"name":i18n.t('noClient.nameNoclient'),"type":i18n.t('noClient.typeNoclient'),"tel":'',"compras":[],"total_compra":0},
            ];
            state.catdb=[
                {'id':'uncategorized','name':"Sin categoria",'parents':[],'level':0,'children':[],
            'desc':'Productos sin descripicion','parentid':'','qtyprod':0,invAlert:25,'childs':0}
            ];
            state.sales=[];
            state.fournDb=[
                {'id':'fourn1','name':i18n.t('noFournName')}
            ];
            state.propriedades=[];
            state.bills=[];
            if(process.platform!='browser'){
              if (typeof (process.versions.electron) === 'string') {
                // Electron specific code
                const electronStore = window.require('electron-store');
                const db = new electronStore();
                db.clear()
                db.set('clients',state.clients)
                db.set('catdb',state.catdb)
                db.set('fournDb',state.fournDb)
              }}
        },
        updateJsonDb:(state)=>{
            
            const electronStore = window.require('electron-store');
            const db = new electronStore();
            db.set('products',state.products)
            db.set('clients',state.clients)
                db.set('catdb',state.catdb)
                db.set('bills',state.bills)
                db.set('sales',state.sales)
                db.set('propriedades',state.propriedades)
                db.set('fournDb',state.fournDb)
        },
        loadElectronDb:(state)=>{
            const electronStore = window.require('electron-store');
            const db = new electronStore();
            if(db.get('products')){
            state.products=db.get('products')}
            if(db.get('clients')){
            state.clients= db.get('clients')}
            if(db.get('clients')){
            state.bills=db.get('bills')}
            if(db.get('sales')){
            state.sales= db.get('sales')}
            if(db.get('propriedades')){
            state.propriedades=db.get('propriedades')}
            if(db.get('catdb')){
            state.catdb= db.get('catdb')}
            if(db.get('fournDb')){
            state.fournDb=db.get('fournDb')}
        },
        modifClientTotalBuy:(state,{id,idsale,total})=>{
            var pos=state.clients.map(function(e) { return e.id; }).indexOf(id);

            state.clients[pos].total_compra-=total

            var clientcompras =  state.clients[pos].compras
            var temparray=[]

            for(var u=0;u<clientcompras.length;u++){
                if(idsale!=clientcompras[u]){temparray.push(clientcompras[u])}
                
            }
            state.clients[pos].compras=temparray
        },
        updateQtySale:(state,{prodid,sale,returnQty})=>{
            
            var pos=state.sales.map(function(e) { return e.id; }).indexOf(sale.id);

            

            var products=state.sales[pos].products
          var temparray=[]
          var precio=0
          for(var i=0;i<products.length;i++){
              if(prodid==products[i].id){
                  products[i].qty-=returnQty
                  pos=state.products.map(function(e) { return e.id; }).indexOf(products[i].id);
                  state.products[pos].currenttInv+=returnQty
                
                precio=products[i].pu*returnQty
                products[i].total-=precio

                pos=state.clients.map(function(e) { return e.id; }).indexOf(sale.clientId);
                  state.clients[pos].total_compra-=precio
              }
              temparray.push(products[i])
          }

          //this.saleactive.products=temparray
          pos=state.sales.map(function(e) { return e.id; }).indexOf(sale.id);
                  state.sales[pos].products=temparray
                  state.sales[pos].total-=precio
        },
    },
    actions:{
        deleteCat:(context,payload)=>{
            context.commit('deleteCat',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        updateJsonDb:(context)=>{
            context.commit('updateJsonDb')
        },
        deleteSale:(context,payload)=>{
            context.commit('deleteSale',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        eraseDb:(context,payload)=>{
            context.commit('eraseDb',payload)
        },
        loadElectronDb:(context)=>{
            context.commit('loadElectronDb')
        },
        modifClientTotalBuy:(context,payload)=>{
            context.commit('deleteCat',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        restoreProdInv:(context,payload)=>{
            context.commit('restoreProdInv',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        updateQtySale:(context,payload)=>{
            context.commit('updateQtySale',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        deleteProp:(context,payload)=>{
            context.commit('deleteProp',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        modifInv:(context,payload)=>{
            context.commit('modifInv',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        deleteClient:(context,payload)=>{
            context.commit('deleteClient',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        deleteBill:(context,payload)=>{
            context.commit('deleteBill',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addSale:(context,payload)=>{
            context.commit('addSale',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addBuy:(context,payload)=>{
            context.commit('addBuy',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        deleteProd:(context,payload)=>{
            context.commit('deleteProd',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addCat:(context,payload)=>{
            context.commit('addCat',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addClient:(context,payload)=>{
            context.commit('addClient',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addProd:(context,payload)=>{
            context.commit('addProd',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        addProp:(context,payload)=>{
            context.commit('addProp',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        modifProp:(context,payload)=>{
            context.commit('modifProp',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        updateCatChildCount:(context,payload)=>{
            context.commit('updateCatChildCount',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        modifProductCat:(context,payload)=>{
            context.commit('modifProductCat',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        modifProduct:(context,payload)=>{
            context.commit('modifProduct',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        },
        modifProductCatQty:(context,payload)=>{
            context.commit('modifProductCatQty',payload)
            if(process.platform!='browser'){
            if (typeof (process.versions.electron) === 'string') {
                context.dispatch('updateJsonDb')
            }}
        }
    }
})